<app-loading-spinner />
<router-outlet></router-outlet>
